import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["csvLink"]

    connect() {
    // Listen for Turbo Frame loading events
    document.addEventListener('turbo:before-fetch-request', this.showLoading.bind(this))
    document.addEventListener('turbo:before-fetch-response', this.hideLoading.bind(this))

    // Bind CSV download handler
    this.handleCsvDownload = this.handleCsvDownload.bind(this)

    // Update CSV link on initial load
    this.updateCsvLink()
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('turbo:before-fetch-request', this.showLoading.bind(this))
    document.removeEventListener('turbo:before-fetch-response', this.hideLoading.bind(this))
  }

    filterChanged() {
    this.updateCsvLink()
    this.element.requestSubmit()
  }

  clearFilters() {
    // Reset all filter inputs
    const inputs = this.element.querySelectorAll('input[type="date"], select')
    inputs.forEach(input => {
      if (input.type === 'date') {
        input.value = ''
      } else if (input.tagName === 'SELECT') {
        input.selectedIndex = 0
      }
    })

    // Update CSV link with cleared values
    this.updateCsvLink()

    // Submit the form to update results using requestSubmit for proper Turbo handling
    this.element.requestSubmit()
  }

    updateCsvLink() {
    if (!this.hasCsvLinkTarget) return

    // Get current form values
    const formData = new FormData(this.element)
    const params = new URLSearchParams()

    // Add format parameter
    params.set('format', 'csv')

    // Add filter parameters if they have values
    const fromDate = formData.get('from_date')
    const toDate = formData.get('to_date')
    const securityControl = formData.get('security_control')
    const status = formData.get('status')
    const column = formData.get('column')
    const direction = formData.get('direction')

    if (fromDate) params.set('from_date', fromDate)
    if (toDate) params.set('to_date', toDate)
    if (securityControl) params.set('security_control', securityControl)
    if (status) params.set('status', status)
    if (column) params.set('column', column)
    if (direction) params.set('direction', direction)

        // Update the CSV link href
    const baseUrl = this.element.action || window.location.pathname
    this.csvLinkTarget.href = `${baseUrl}?${params.toString()}`

    // Remove existing event listener and add new one to avoid duplicates
    this.csvLinkTarget.removeEventListener('click', this.handleCsvDownload)
    this.csvLinkTarget.addEventListener('click', this.handleCsvDownload)
  }

  handleCsvDownload(event) {
    // Show loading spinner for CSV download
    const spinner = document.getElementById('issues-loading-spinner')
    if (spinner) {
      // Update loading message for CSV download
      const loadingText = spinner.querySelector('span')
      if (loadingText) {
        loadingText.textContent = 'Preparing CSV download...'
      }
      spinner.classList.remove('hidden')

      // Hide spinner after download starts (file downloads typically start within 3 seconds)
      setTimeout(() => {
        spinner.classList.add('hidden')
        // Reset loading message back to default
        if (loadingText) {
          loadingText.textContent = 'Loading alerts...'
        }
      }, 3000)
    }
  }

  showLoading(event) {
    // Only show loading for requests targeting the issues-table frame
    if (event.detail?.fetchOptions?.headers?.['Turbo-Frame'] === 'issues-table' ||
        event.target?.getAttribute?.('data-turbo-frame') === 'issues-table') {
      const spinner = document.getElementById('issues-loading-spinner')
      if (spinner) {
        spinner.classList.remove('hidden')
      }
    }
  }

  hideLoading(event) {
    // Hide loading spinner for any issues-table frame requests
    const spinner = document.getElementById('issues-loading-spinner')
    if (spinner) {
      spinner.classList.add('hidden')
    }
  }
}
